import {
  desktopL,
  desktop,
  laptop,
  laptopS,
  tablet,
  mobileL,
  mobileM,
  mobileS,
  mobileXS,
} from './breakpoints';

export const mainTheme = {
  name: 'main',
  colors: {
    main: '#1890ff',
    disabled: '#87c0f5',
    secondary: '#rgb(255, 255, 255, 0.6)',
    hover: '#74879B',
    accent: '#021D3D',
    border: '#E8E8E8',
    grayLight: 'rgba(126, 127, 130, 0.2)',
    gray: '#7E7F82',
    gray50: '#454955',
    white: '#FBFBFB',
    whiteBackground: '#FAFAFA',
    black: '#212325',
    black500: '#000',
    stroke: '#E5E7EA',
    error: '#B00020',
  },
  maxWidth: '1280px',
  maxWidthDesktop: '1110px',
  maxWidthLaptop: '1000px',
  maxWidthLaptopS: '720px',
  maxWidthTablet: '480px',
  maxWidthMobileL: '95%',
  maxWidthMobileM: '95%',
  maxWidthMobileS: '95%',
  maxWidthMobileXS: '95%',
  borderRadius: '12px',
  boxShadowBase: `0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),
  0 9px 28px 8px rgba(0, 0, 0, 0.05)`,
  transition: {
    short: '0.3s',
    normal: '1s',
    long: '5s',
  },
  font: 'Roboto, sans-serif',
  fontSizes: {
    xxs: '12px',
    xs2: '13px',
    xs: '14px',
    s: '16px',
    sm: '18px',
    m: '20px',
    md: '22px',
    mdl: '24px',
    l: '32px',
    xl: '42px',
    xxl: '48px',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 600,
    bolder: 700,
  },
  paddings: {
    l: '30px',
    m: '20px',
    s: '10px',
  },
  media: {
    desktopL: `@media screen and (min-width: ${desktopL}px)`,
    desktop: `@media screen and (max-width: ${desktop}px)`,
    laptop: `@media screen and (max-width: ${laptop}px)`,
    laptopS: `@media screen and (max-width: ${laptopS}px)`,
    tablet: `@media screen and (max-width: ${tablet}px)`,
    mobileL: `@media screen and (max-width: ${mobileL}px)`,
    mobileM: `@media screen and (max-width: ${mobileM}px)`,
    mobileS: `@media screen and (max-width: ${mobileS}px)`,
    mobileXS: `@media screen and (max-width: ${mobileXS}px)`,
  },
  shadow: 'box-shadow: 0px -2px 22px -3px #000;',
};
